/**
 * finixt-ui's Spinner, announced: the package's is a bare span, so the wrapper
 * carries the status role and the label a screen reader needs.
 */
import { Spinner as FinixtSpinner } from './finixt.js';

export function Spinner({
  size = 16,
  label = 'Loading',
}: {
  size?: number | undefined;
  label?: string | undefined;
}) {
  return (
    <span role="status" aria-label={label} style={{ display: 'inline-flex' }}>
      <FinixtSpinner size={size} />
    </span>
  );
}
